<template>
  <v-footer
      v-if="currentDoc && got_feature('feature_invoice_lines')"  
      :height="invoice_lines_height" style="background-color:white; bottom:50px"
      inset
      app
      class="pa-0 footer"
    >

    <MessagePopup v-if="show_message" :message="message" :show_message="show_message" @close-message="closeMessage"></MessagePopup>
    <v-dialog v-if="currentDoc && screen_data" v-model="screen_data.excel_pop_up" max-width="660">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h6 primary--text">Subir excel líneas</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="px-7">
            <v-row>
              <v-col align="center" class="pb-0">
                  <v-img src="/icon_table.svg" width="39" />
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <span class="text-h6 primary--text">Orden Cabecera</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <p class="mb-0">Necesitamos la siguiente estructura</p>
                <p class="font-weight-bold">Cantidad / Precio unitario / Total bruto</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  class="rounded-lg"
                  label="Archivo"
                  v-model="screen_data.file"
                  prepend-icon="mdi-paperclip"
                  color="primary"
                  accept=" .xls, .xlsx, .xlsm, .ods"
                  :clearable="false"
                  :loading="false"
                  :rules="[v => !!v || 'Archivo requerido']"
                  :error="error_upload_file"
                  outlined
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      <v-card-actions class="acction_btns">
          <v-spacer></v-spacer>
          <app-btn outlined @click="screen_data.cancel_pop_up()">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="screen_data.confirm_pop_up()" 
            variant="text"
            :disabled="!screen_data.file"
          >
            Subir
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-toolbar clipped>
        <v-tabs v-model="tab" grow>
          <v-tab @click="set_active_tab('invoice_lines')"> Lineas</v-tab>
          <v-tab @click="set_active_tab('descuentos')" >Descuentos </v-tab>
          <v-tab @click="set_active_tab('otros_gastos')" >Otros gastos</v-tab>
        </v-tabs>
        <v-btn icon color="primary" @click="click_show_invoice_lines()">
        <!-- Establecemos los TABS -->
        
          <v-icon v-if="show_invoice_lines">mdi-arrow-down</v-icon>
          <v-icon v-else>mdi-arrow-up</v-icon></v-btn>
        
        
        <v-spacer/>
        <template cols="1" align="left" >
                <v-btn outlined class="mr-2"  color="primary" @click="invoice_lines_component.import_excel_lines()">
                  <v-icon v-once>mdi-upload</v-icon>
                </v-btn>
                
        </template>
        <template cols="1" align="left" >
                <v-btn outlined class="mr-2"  color="primary" @click="reverse_amounts_in_lines()">
                  <v-icon v-once>mdi-autorenew</v-icon>
                </v-btn>
                
        </template>
        <template >
          <v-btn  color="primary" outlined 
          class="mr-2" 
            v-on="{ click: addInvoiceLine }"
            ><v-icon v-once>
                  mdi-plus
          </v-icon></v-btn>
          
        </template>
        <template >
          <v-btn  color="primary" outlined 
          class="mr-2" 
            v-on="{ click: saveInvoiceLines }"
            ><v-icon v-once>
                  mdi-content-save
          </v-icon></v-btn>
          
        </template>
          <v-btn  outlined color="primary" @click="clickForceMove()">
            Lineas factura
          </v-btn>
      </v-toolbar>
      <v-card
        
        flat
        width="100%"
        height="270"
        class="text-center ma-6"
        style="overflow-y:scroll"
      >
        


              <!-- Y, ahora, el contenido -->
        <v-tabs-items v-model="tab">
          
          <v-tab-item>
            <v-row class="table-head-row" no-gutters>
              <v-col cols="2" class="primary--text table-right-head"/>
              
              <v-col cols="4" class="primary--text table-head">Descripcion</v-col>
              <v-col cols="1" class="primary--text table-head">Precio Unitario</v-col>
              <v-col cols="1" class="primary--text table-head">Cantidad</v-col>
              <v-col cols="1" class="primary--text table-head">Importe sin impuestos</v-col>
              <v-col cols="1" class="primary--text table-head">IVA</v-col>
              <!-- <v-col cols="1" class="primary--text table-head">RET</v-col> -->
              <v-col cols="1" class="primary--text table-head">Cuota</v-col>
              <v-col cols="1" class="primary--text table-left-head">Importe total</v-col>
            </v-row>
            
            <v-row  class="table-row" no-gutters v-for="(invoice_line, index) in screen_data.lines" v-bind:key="index" align="center" justify="center">
              
              <v-col cols="2" class="ftable-right-head">
                <v-btn icon color="primary" @click="deleteInvoiceLine(invoice_line)" ><v-icon v-once>
                  mdi-delete
                </v-icon></v-btn>
                <!-- <v-btn  icon color="primary" @click="saveInvoiceLine(invoice_line)" ><v-icon :color="invoice_line.save_color" v-once>
                  mdi-content-save
                </v-icon></v-btn> -->
                {{ invoice_line.id }}
              </v-col>
              
              <v-col cols="4" class="table-head">
                <DocTextField
                      label=""
                      
                      :required="true"
                      v-model="invoice_line.description"
                      :class="{invalid:currentDoc}"
                      :kind="'invoice_line_kind'"
                      :items = [invoice_line]
                       @get-values="getValues"
                       @reset-items="resetItems"
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-head" >
                <DocTextField 
                  label="" 
                  v-model="invoice_line.unit_price_without_tax" 
                  :required="true"
                  hide-details
                  :kind="'invoice_line_kind'"
                  @change_invoice_line="quantityChange(invoice_line)"
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-head" >
                <DocTextField
                  label="" 
                  @change_invoice_line="quantityChange(invoice_line)"
                  :required="true"
                  v-model="invoice_line.quantity" 
                  :kind="'invoice_line_kind'"
                  :items = [invoice_line]
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-head" >
                <DocTextField
                  label="" 
                  :required="true"
                  v-model="invoice_line.gross_amount" 
                  readonly
                ></DocTextField>
                
              </v-col>
              <v-col cols="1" class="table-head" >
                <!-- <DocTextField
                  label="" 
                  :required="true"
                  v-model="invoice_line.taxes[0].rate*100" 
                  :kind="'invoice_line_kind'"
                  @change_invoice_line="change_tax_line(invoice_line)"
                ></DocTextField> -->
                <DocTextField
                  label="" 
                  :value="(invoice_line.taxes[0].rate*100).toString() + '%'"
                  :kind="'invoice_line_kind'"
                  readonly>
                </DocTextField>
                
              </v-col>
              <!-- <v-col cols="1" class="table-head" >
                <DocTextField
                  label="" 
                  
                  :required="true"
                  v-model="invoice_line.retention" 
                  
                ></DocTextField>
                
              </v-col> -->
              <v-col cols="1" class="table-head" >
                <DocTextField
                  label="" 
                  :required="true"
                  :value="invoice_line.taxes[0].amount" 
                  readonly
                ></DocTextField>
                
              </v-col>
              <v-col cols="1" class="table-left-head">
                <DocTextField 
                  label="" 
                  :kind="'invoice_line_kind'"
                  :value="get_total_amount(invoice_line)"
                  readonly

                ></DocTextField>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row class="table-head-row" no-gutters align="center" justify="center">
              <v-col cols="1" class="primary--text table-right-head"/>
              <v-col cols="6" class="primary--text table-head">Descripcion</v-col>
              <v-col cols="1" class="primary--text table-left-head">Importe</v-col>
              <v-col cols="1" class="primary--text table-left-head">Porcentaje</v-col>
            </v-row>
            <v-row  class="table-row" no-gutters v-for="(discount_line, index) in discount_lines" v-bind:key="index" align="center" justify="center">
            <v-col cols="1" class="ftable-right-head">
                <v-btn icon color="primary" @click="deleteDiscount(discount_line)" ><v-icon v-once>
                  mdi-delete
                </v-icon></v-btn>
                <v-btn icon color="primary" @click="saveDiscount(discount_line)" ><v-icon v-once>
                  mdi-content-save
                </v-icon></v-btn>
                
              </v-col>
              <v-col cols="6" class="table-head">
                <DocTextField
                      label=""
                      @change_invoice_line="changeDiscount(discount_line)"
                      :required="true"
                      v-model="discount_line.DiscountReason" 
                      :class="{invalid:currentDoc}"
                      :kind="'invoice_line_kind'"
                      
                       @get-values="getValues"
                       @reset-items="resetItems"
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-head">
                <DocTextField 
                  label="" 
                  @change_invoice_line="changeDiscount(discount_line)"
                  :kind="'invoice_line_kind'"
                  v-model="discount_line.DiscountAmount" 
                  

                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-left-head">
                <DocTextField 
                  label="" 
                  @change_invoice_line="changeDiscount(discount_line)"
                  :kind="'invoice_line_kind'"
                  v-model="discount_line.DiscountRate" 
                  

                ></DocTextField>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row class="table-head-row" no-gutters align="center" justify="center">
              <v-col cols="1" class="primary--text table-right-head"/>
              <v-col cols="6" class="primary--text table-head">Descripcion</v-col>
              <v-col cols="1" class="primary--text table-head">Importe</v-col>
              <v-col cols="1" class="primary--text table-left-head">Porcentaje</v-col>
            </v-row>
            <v-row  class="table-row" no-gutters v-for="(otro_gasto_line, index) in otros_gastos_lines" v-bind:key="index" align="center" justify="center">
            <v-col cols="1" class="ftable-right-head">
                <v-btn icon color="primary" @click="deleteInvoiceLine(otro_gasto_line)" ><v-icon v-once>
                  mdi-delete
                </v-icon></v-btn>
                <v-btn icon color="primary" @click="saveInvoiceLine(otro_gasto_line)" ><v-icon v-once>
                  mdi-content-save
                </v-icon></v-btn>
                
              </v-col>
              <v-col cols="6" class="table-head">
                <DocTextField
                      label=""
                      @change_invoice_line="changeGasto(otro_gasto_line)"
                      :required="true"
                      v-model="otro_gasto_line.ChargeReason" 
                      :class="{invalid:currentDoc}"
                      :kind="'invoice_line_kind'"
                      :items = [otro_gasto_line]
                       @get-values="getValues"
                       @reset-items="resetItems"
                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-head">
                <DocTextField 
                  label="" 
                  @change_invoice_line="changeGasto(otro_gasto_line)"
                  v-model="otro_gasto_line.ChargeAmount"           
                  :kind="'invoice_line_kind'"

                ></DocTextField>
              </v-col>
              <v-col cols="1" class="table-left-head">
                <DocTextField 
                  label="" 
                  @change_invoice_line="changeGasto(otro_gasto_line)"
                  v-model="otro_gasto_line.ChargeRate"           
                  :kind="'invoice_line_kind'"

                ></DocTextField>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-footer>
</template>

<script>
import DocTextField from "./DocTextField.vue"
import MessagePopup from "./MessagePopup.vue";
import { mapGetters,mapActions, mapState, mapMutations} from "vuex"
import { createHelpers ,mapFields} from 'vuex-map-fields'
import {round, isValidDate} from '../utils'
import { vuexPrefix } from "../store/vuex_utils";
import { validateAccount } from "../utils/account_validation"
import {evaluate} from 'mathjs'
import { canEditAccountMove } from "../modules/invoices/domain/Invoice"
import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"
import { documents as api_documents } from "../api";
import AppBtn from '@/components/layout/AppBtn.vue';

import awsconfig from '../aws-exports';
import {InvoiceLinesComponent} from '../modules/facturae/app/InvoiceEditorComponent'
import {S3Repository} from '../modules/shared/infra/S3Repository'
import {VueLinesScreenData} from '../modules/facturae/infra/VueInvoiceEditorScreenData'

const { mapMultiRowFields } = createHelpers({
  getterType: 'documents/getAccountMoveField',
  mutationType: 'documents/updateAccountMoveField',
});

    export default {
        name:'InvoiceLines',
        props:{
          invoice_lines:{
            type: Array,
            required: true
          }
        },
        data(){
          const screen_data = new VueLinesScreenData()
          
          return {
            loading_doc_account_moves: false,
            tab: 0,
            active_tab: 'invoice_lines',
            showPaymentAccountDialog: false,
            manualAccount: 0,
            message: '',
            show_message: false,
            invoice_lines: [],
            discount_lines: [],
            otros_gastos_lines:[],
            screen_data: screen_data,
            invoice_lines_component: null,
            error_upload_file: false,
          }
        },
        components:{
          DocTextField,
          MessagePopup,
          AppBtn
        },

        computed:{
          ...mapGetters({
            currentDoc: 'documents/currentDocument',
            inRotationMode: 'documents/inRotationMode',
            dirty: 'documents/dirty',
            isWaitingFlow: "documents/isWaitingFlow",
            got_feature:'got_feature',
            userData: 'me/userData',
            show_invoice_lines: 'documents/show_invoice_lines',
            invoice_lines_height: 'documents/invoice_lines_height'
          }),
          ...mapState([
            'currentCompany','session_information'
          ]),
          //account_move(){
          //  return (this.currentDoc && this.currentDoc.accountMoves.length)?this.currentDoc.accountMoves[0]:undefined
          //},
          //...mapMultiRowFields(['account_move_lines', 'paid_account_move_lines','otros_datos']),
          ...mapFields('me',vuexPrefix('',['feature_payment_move'],'userData.available_features.')),
          ...mapFields('cru', ['accounts']),
          totalDebit(){
            try{
              if(this.account_move){
                return round(this.invoice_lines.map(x=>x.debit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
          },
          totalCredit(){
            try{
              if(this.account_move){
                return round(this.invoice_lines.map(x=>x.credit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
          },
          balance(){
            return round(this.totalDebit-this.totalCredit)
          },
          balancePaid(){
            return round(this.totalDebitPaid-this.totalCreditPaid)
          },
          paid_account_move(){
            return (this.currentDoc && this.currentDoc.accountMoves.length
              && this.currentDoc.accountMoves[0].paid_account_move && this.currentDoc.accountMoves[0].paid_account_move.length
            )
              ? this.currentDoc.accountMoves[0].paid_account_move[0] : undefined
          },
          
          
          /*accountRules() {
            return [
              (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
            ]
          },*/
          
        },
        async mounted() {
          this.accounts = [];
          this.creds = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
          });
          this.creds.params.Logins = this.creds.params.Logins || {};
          this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
          this.creds.expired = true;
          AWS.config.update({
              region: awsconfig['aws_user_files_s3_bucket_region'],
              credentials: this.creds,
          });
          let s3_repo = new S3Repository(AWS,'excel_lines')
          this.screen_data.setLines(this.invoice_lines)
          this.invoice_lines_component = new InvoiceLinesComponent(static_invoice_repo,s3_repo,this.screen_data)

        },
        methods:{
          num(x){
            if (x==='') {
              return 0;
            }else{
              return evaluate(x);
            }

          },
          manejarEvento(datos){
            console.log('estoy manejando desde el padre');
          },
          get_total_amount(line){
            return parseFloat(line.gross_amount*(1+line.taxes[0].rate)).toFixed(2);
          },

          computar_total(){
            let gross_amount = 0
            //let invoice_lines =  this.currentDoc.invoice_lines
            this.invoice_lines.forEach((line) => {
              gross_amount = gross_amount + parseFloat(line.gross_amount);
            })
            this.currentDoc.metadata.totalGrossAmount = gross_amount;
          },

          computar_total_sin_impuestos(){
            //Esto es el total de la factura sin impuestos (suma de lineas) menos los descuentos y sumados los otros gastos
            let total_sin_impuestos = this.currentDoc.metadata.totalGrossAmount
            if(this.currentDoc.metadata.generalDiscounts){
              total_sin_impuestos = (parseFloat(total_sin_impuestos) - parseFloat(this.currentDoc.metadata.generalDiscounts[0].DiscountAmount)).toFixed(2);
            }
            if(this.currentDoc.metadata.generalSurcharges){
              total_sin_impuestos = (parseFloat(total_sin_impuestos) + parseFloat(this.currentDoc.metadata.generalSurcharges[0].ChargeAmount)).toFixed(2);
            }
            
            this.currentDoc.metadata.totalGrossAmountBeforeTaxes = total_sin_impuestos;
          },

          computar_total_factura(){
            let total_cost = 0
            let invoice_lines =  this.currentDoc.invoice_lines
            this.invoice_lines.forEach((line) => {
              total_cost = total_cost + parseFloat(line.total_cost);
            })

            this.currentDoc.metadata.total_amount = total_cost;
          },
          computar_total_taxes_factura(){
            let tax_map = {}
            
            this.invoice_lines.forEach((line) => {
              let tax_name = parseFloat(line.TaxRate).toFixed(2).toString();
              if (!(tax_name in tax_map)){
                
                this.$set(tax_map,tax_name,{TaxAmount:0,TaxRate:tax_name,TaxTypeCode:"01",TaxableBase:0});
              }
              
              //console.log(tax_map[tax_name]['TaxAmount']);
              
              tax_map[tax_name]['TaxAmount'] = (parseFloat(tax_map[tax_name]['TaxAmount']) + parseFloat(line.metadata.TaxesOutputs[0].TaxAmount)).toFixed(2);
              tax_map[tax_name]['TaxableBase'] = (parseFloat(tax_map[tax_name]['TaxableBase']) + parseFloat(line.metadata.TaxesOutputs[0].TaxableBase)).toFixed(2);
              
            })
            this.currentDoc.metadata.invoice_taxes = [];
            for (let key in tax_map){
              this.currentDoc.metadata.invoice_taxes.push(tax_map[key]);
            }
            
          },

          update_invoice_values(){
            this.computar_total();
            this.computar_total_sin_impuestos();
            this.computar_total_taxes_factura();
            this.computar_total_factura();
            
            //this.currentDoc.metadata.totalGrossAmount = total_cost;
          },

          get_line_tax(line){
            
            try{
              if(line.metadata.TaxesOutputs){
                
                return parseFloat(line.TaxRate);
              }
              else{
                console.log('No tenemos valor');
                return 0;
              }
            } catch (error) {
              console.log(error);
              return 0;
            } 
          },
          
          change_tax_line(line){
            
            line.metadata.TaxesOutputs[0].TaxRate = line.TaxRate;
            let tax_amount = line.unit_price_without_tax * (this.get_line_tax(line)/100)
            line.metadata.TaxesOutputs[0].TaxAmount = tax_amount;
            line.metadata.TaxesOutputs[0].TaxableBase = line.total_cost;
            
            this.changeLine(line);
          },

          quantityChange(line){
            this.changeLine(line);
          },
          
          changeLine(line){
            //console.log('quantityChange')
            //line.save_color = 'red';
            //update precio sin impuestos 
            let gross_amount = (line.quantity * line.unit_price_without_tax) ;
            line.gross_amount = gross_amount;
            line.total_cost = gross_amount;
            //update importe total con impuestos
            line.taxes[0].base = gross_amount;
            line.taxes[0].amount = gross_amount * line.taxes[0].rate;

            //actualizamos el valor de la factura
            //this.update_invoice_values();
            //cambiamos los valores de la factura
            
          
          },
          changeDiscount(discount){
            console.log('aplicamos el cambio');
            //this.currentDoc.metadata.generalDiscounts[0].DiscountAmount = discount.amount;
            //this.currentDoc.metadata.generalDiscounts[0].DiscountReason = discount.description;
            this.update_invoice_values();
          },
          changeGasto(otro_gasto_line){
            if (this.currentDoc.metadata.generalSurCharges){
              this.currentDoc.metadata.generalSurcharges[0].ChargeAmount = otro_gasto_line.amount;
              this.currentDoc.metadata.generalSurcharges[0].ChargeReason = otro_gasto_line.description;
            }
            this.update_invoice_values();
          },

          ...mapMutations({
            //addLine:'documents/addLine', 
            addPaidLine: 'documents/addPaidLine',
            deleteLine:'documents/deleteLine',
            deletePaidLine: 'documents/deletePaidLine',
            forceMove: "documents/forceMove",
          }),
          ...mapActions({
            setForcedMove: "documents/setForcedMove",
            fetchDocumentMetadata: "documents/fetchDocumentMetadata",
            continueFlow: "documents/continueFlow",
            cancelEditFlow: "documents/cancelEditFlow",
            saveAccountMoves: "documents/saveAccountMoves",
            createManualPaymentMoves: "documents/createManualPaymentMoves",
            showInvoiceLinesFooter: "documents/showInvoiceLinesFooter",
            hideInvoiceLinesFooter: "documents/hideInvoiceLinesFooter",
            initInvoiceLinesFooter: "documents/initInvoiceLinesFooter"
          }),
          ...mapActions("cru", ['getAccounts']),
          showMessage(m){
            this.message=m;
            this.show_message=true;
          },
          closeMessage(){
            this.show_message=false;
          },
          click_show_invoice_lines(){
            if(this.show_invoice_lines){
              this.hide_lines()
            }
            else{
              this.show_lines()
            }
          },
          
          enableDisableAccountMoveInputs() {
            let feature_repo = new VueFeatureRepository(this.got_feature)
            let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
            if (message){
              this.showMessage(message);
            } else {
              this.loading_doc_account_moves = true;
              this.setForcedMove(!this.currentDoc.forced_move);
              this.fetchDocumentMetadata({ id: this.currentDoc.id }).then(() => {
                if(!this.account_move){
                  this.hide_lines()
                }
                this.loading_doc_account_moves = false;
              });
            }
          },
          start_check_async_job_state(id){
            this.check_async_job_state(id)
          },
          check_async_job_state(id){
            if(id==this.$store.state.documents.document.id.toString()){
                this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then(() => {
                if(['pending','running'].includes(this.$store.state.documents.document.async_job_state)){
                  setTimeout(()=>this.check_async_job_state(this.$store.state.documents.document.id),3000)
                }
                else{
                  if(!this.account_move){
                    this.hide_lines()
                  }
                  else{
                    this.show_lines()
                  }
                }
              })
            }
            
          },
          addInvoiceLine() {
            if (this.active_tab == 'invoice_lines'){
            let TaxesOutputs = [{'TaxRate':0, 'TaxAmount':0,'TaxTypeCode':'01','TaxableBase':0},]
            let newLine = {
              account:'',
              TaxRate:TaxesOutputs[0]['TaxRate'],
              total_amount:0.0,
              save_color : 'red',
              gross_amount:0.0,
              description: '',
              total_cost:0.0,
              unit_price_without_tax:0.0,
              tax:0,
              retention:0,
              metadata:{'TaxesOutputs':TaxesOutputs}
            }
            this.invoice_lines.push(newLine);
            this.currentDoc.invoice_lines.push(newLine)
          } 
          else if (this.active_tab == 'descuentos'){
            let newLine = {
              description :'',
              amount: 0
            }
            this.discount_lines.push(newLine)
          }
          else if (this.active_tab == 'otros_gastos'){
            let newLine = {
              description :'',
              amount: 0
            }
            this.otros_gastos_lines.push(newLine)
          }
          },

          deleteInvoiceLine(line){
            
            //this.invoice_lines[index];
            //console.log(this.invoice_lines[index]);
            let data = {};
            data['invoice_line_id'] = line.id;
            data['document_id'] = this.currentDoc.id;
            api_documents.deleteInvoiceLine(data);
            //this.invoice_lines.splice(index,1)
          },

          saveInvoiceLine(line){
            //let line = this.invoice_lines[index];
            let data = {};
            data['invoice_line_id'] = line.id;
            data['document_id'] = this.currentDoc.id;
            data['total_cost'] = line.total_cost;
            data['description'] = line.description;
            data['quantity'] = line.quantity;
            data['gross_amount'] = line.gross_amount;
            data['unit_price_without_tax'] = line.unit_price_without_tax;
            data['TaxesOutputs'] = line.metadata.TaxesOutputs
            data['metadata'] = line.metadata
            
            api_documents.createInvoiceLine(data);
          },

          clickForceMove() {
            let feature_repo = new VueFeatureRepository(this.got_feature)
            let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
            if (message){
              this.showMessage(message);
            } else {
              this.loading_doc_account_moves = true;
              this.setForcedMove(true);
              this.forceMove()
              this.saveAccountMoves()
              this.loading_doc_account_moves = false;
              this.show_lines()
            }
          },
          cancelEdit() {
            this.loading_doc_account_moves = true;
            this.setForcedMove(false);
            this.hide_lines()
            this.cancelEditFlow().then(() => {
              if(!this.account_move){
                this.hide_lines()
              }
              else{
                this.show_lines()
              }
              if(['pending','running'].includes(this.currentDoc.async_job_state)){
                setTimeout(()=>this.start_check_async_job_state(this.currentDoc.id),3000)
              }
              this.loading_doc_account_moves = false;
            });
            
          },
          saveInvoiceLines(){
            console.log('guardamos las lineas');
          },
          hide_lines(){
            this.hideInvoiceLinesFooter();
          },
          show_lines(){
            this.showInvoiceLinesFooter();
          },
          isValidDate(d_str){
            return isValidDate(d_str)
          },
          set_active_tab(tab_value){
            this.active_tab = tab_value
          },
          openShowPaymentAccountDialog() {
            this.showPaymentAccountDialog = true
          },
          noCreatePaymentLine() {            
            this.showPaymentAccountDialog = false
          },
          createPaymentLine() {
            /*try {
              this.createManualPaymentMoves({
                "document_id" : this.currentDoc.id,
                "account" : this.manualAccount
              }).then(() => {}
                 //setTimeout(() => this.check_async_job_state(this.$store.state.documents.document.id), 2000)
                 )

              this.showPaymentAccountDialog = false
            } catch(err) {
              console.error(err)
            } */           
          },
          getValues(params) {
            this.getAccounts(params).then(() => {});
          },
          resetItems(params) {
            this.accounts = params;
          },
          requiredTypeIvaLine(line) {
            return this.currentDoc && line && line.account && (line.account.startsWith('472') || line.account.startsWith('477')) && !line.type_iva && !((this.currentDoc.iva_parcial || this.currentDoc.gasto_iva_parcial) && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params.hasOwnProperty('allow_account_exc_expens_lines_no_IVA') && line.account.startsWith(this.currentCompany.companydb_type.params['allow_account_exc_expens_lines_no_IVA']));
          },
          getIconColor(line){
            if(line.TaxRate == '10'){
              return 'blue';
            }
            return 'red';
          },
        },
        watch: {
          'invoice_lines': {
            handler(newItems, oldItems) {
              // Aquí puedes realizar acciones adicionales cuando la matriz 'items' cambia
              console.log('Items changed:', newItems);
            },
            deep: true, // Observar cambios profundos en los elementos de la matriz
          },
        },
        // mounted(){
        //   //console.log(this.currentDoc);
        //   this.initInvoiceLinesFooter(this.account_move);
          
        //   this.invoice_lines = [];
        //   //let lines = this.currentDoc.invoice_lines;
        //   this.discount_lines = [];
        //   this.otros_gastos_lines = [];
          
        //   //establecemos las lineas de factura
        //   this.currentDoc.invoice_lines.forEach((line) => {
        //     line.tax = line.metadata.TaxesOutputs[0];
        //     line.TaxRate = parseFloat(line.metadata.TaxesOutputs[0].TaxRate).toFixed(2);
        //     line.save_color = 'blue'
        //     this.invoice_lines.push(
        //       line
        //     )
        //   });

        //   //establecemos los descuentos
        //   if(this.currentDoc.metadata.generalDiscounts){
        //     this.currentDoc.metadata.generalDiscounts.forEach((discount) => {
        //       this.discount_lines.push(
        //         discount
        //       )
        //     });
        //   }

        //   //establecemos otros gastos de la factura
        //   if(this.currentDoc.metadata.generalSurcharges){
        //     this.currentDoc.metadata.generalSurcharges.forEach((gasto) => {
        //       this.otros_gastos_lines.push(
        //         gasto
        //       )
        //     })
        //   }
        // }
    }
</script>

<style scoped>
  .table-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-left-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 36px;
  }
  .table-left-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 36px;
  }
</style>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: #663399;
    }
    .primary-border {
        border-color: #663399 !important;
    }
    .table-head {
        border-left-style:solid;
        border-right-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .table-right-head {
        border-right-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .table-left-head {
        border-left-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .total-center-cell {
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: #663399;
      border-width: thin;
    }
    .total-right-cell {
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: #663399;
      border-width: thin;

    }
    .total-left-cell {
      border-bottom-style: solid;
      border-left-style: solid;
      border-right-style: solid;
      border-color: #663399;
      border-width: thin;
    }
    .table-head-row {
      border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-top-style: solid;
        border-color: #663399;
        border-width: thin;
    }
    .table-row{
        border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-color: #663399;
        border-width: thin;
    }
    .table-aux{
      border-color:#663399;
      border-width: thin;
    }
    .footer {
      z-index: 101;
      max-height: 75%;
    }
</style>
